(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mn-3d-viewer"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if (!root || root.dataset.ready) return; root.dataset.ready = '1';
    var mv = root.querySelector('model-viewer'); var mat = null; var g = .6;
    function apply(){ root.style.setProperty('--g', g); if (mat) { try { mat.setEmissiveFactor([g, g * .66, g * .34]); } catch(e){} } if (mv) mv.exposure = .6 + g * .5; }
    mv && mv.addEventListener('load', function(){ try { mat = mv.model.materials[0]; var t = mat.pbrMetallicRoughness.baseColorTexture && mat.pbrMetallicRoughness.baseColorTexture.texture; if (t) mat.emissiveTexture.setTexture(t); } catch(e){} apply(); });
    root.querySelectorAll('[data-g]').forEach(function(b){
      b.addEventListener('click', function(){
        g = parseFloat(b.dataset.g) || 0;
        root.querySelectorAll('[data-g]').forEach(function(o){ var on = o === b; o.classList.toggle('is-on', on); o.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        apply();
      });
    });
    apply();
  }
  function boot(){ document.querySelectorAll('[data-mn-v3d]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mn-x3d"] && !Shopify.designMode) return;
  try {
    
(function () {
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function ease(t) { return t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
  function lerp(a, b, t) { return a + (b - a) * t; }

  function initSky(root, canvas, state) {
    var ctx = canvas.getContext('2d'); if (!ctx) return function () {};
    var stars = [], flies = [], w = 0, h = 0, dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    function resize() {
      var r = canvas.getBoundingClientRect(); w = r.width; h = r.height;
      canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      stars = []; flies = [];
      var ns = Math.round(w * h / 9000);
      for (var i = 0; i < ns; i++) stars.push({ x: Math.random() * w, y: Math.random() * h * .8, r: Math.random() * 1.2 + .3, t: Math.random() * 6.28, s: Math.random() * .02 + .005, z: Math.random() });
      for (var j = 0; j < 22; j++) flies.push({ x: Math.random() * w, y: h * (.35 + Math.random() * .65), r: Math.random() * 1.8 + 1, vx: (Math.random() - .5) * .25, vy: -(Math.random() * .25 + .05), t: Math.random() * 6.28 });
    }
    resize(); window.addEventListener('resize', resize, { passive: true });
    return function draw() {
      ctx.clearRect(0, 0, w, h);
      var g = state.glow, p = state.p;
      for (var i = 0; i < stars.length; i++) {
        var s = stars[i]; s.t += s.s;
        var a = (.35 + .65 * Math.abs(Math.sin(s.t))) * (1 - g * .6);
        ctx.globalAlpha = a; ctx.fillStyle = '#FFF4E0';
        ctx.beginPath(); ctx.arc(s.x, s.y - p * 60 * (s.z + .3), s.r, 0, 6.283); ctx.fill();
      }
      for (var j = 0; j < flies.length; j++) {
        var f = flies[j]; f.t += .03; f.x += f.vx + Math.sin(f.t) * .15; f.y += f.vy;
        if (f.y < h * .2) { f.y = h + 10; f.x = Math.random() * w; }
        var fa = (.25 + .5 * Math.abs(Math.sin(f.t))) * (.35 + g * .65);
        var grd = ctx.createRadialGradient(f.x, f.y, 0, f.x, f.y, f.r * 5);
        grd.addColorStop(0, 'rgba(242,182,109,' + fa + ')'); grd.addColorStop(1, 'rgba(242,182,109,0)');
        ctx.globalAlpha = 1; ctx.fillStyle = grd; ctx.beginPath(); ctx.arc(f.x, f.y, f.r * 5, 0, 6.283); ctx.fill();
      }
      ctx.globalAlpha = 1;
    };
  }

  function init(root) {
    if (!root || root.dataset.ready) return; root.dataset.ready = '1';
    var mv = root.querySelector('model-viewer');
    var body = root.querySelector('.mn-x3d__body');
    var track = root.querySelector('.mn-x3d__track');
    var chs = [].slice.call(root.querySelectorAll('.mn-x3d__ch'));
    var dots = [].slice.call(root.querySelectorAll('.mn-x3d__dots li'));
    var lvEls = [].slice.call(root.querySelectorAll('.mn-x3d__levels span'));
    var clock = root.querySelector('.mn-x3d__clock');
    var n = chs.length; if (!n || !mv) return;
    var kf = chs.map(function (c) { return { th: +c.dataset.theta || 0, ph: +c.dataset.phi || 70, zm: +c.dataset.zoom || 100, g: (+c.dataset.glow || 0) / 100, ef: c.dataset.effect || 'none' }; });
    var pts = [];
    kf.forEach(function (k, i) {
      if (k.ef === 'levels') pts.push([i - .45, .3], [i - .14, .3], [i - .1, .6], [i + .1, .6], [i + .14, 1], [i + .45, 1]);
      else if (k.ef === 'timer') pts.push([i - .35, k.g], [i + .38, 0]);
      else pts.push([i, k.g]);
    });
    pts.sort(function (a, b) { return a[0] - b[0]; });
    function glowAt(x) {
      if (x <= pts[0][0]) return pts[0][1];
      for (var i = 1; i < pts.length; i++) if (x <= pts[i][0]) { var a = pts[i - 1], b = pts[i]; return lerp(a[1], b[1], (x - a[0]) / ((b[0] - a[0]) || 1)); }
      return pts[pts.length - 1][1];
    }
    var state = { p: 0, x: 0, glow: 0, breath: 0 };
    var mat = null, lastG = -1;
    function setGlow(g) {
      if (Math.abs(g - lastG) < .004) return; lastG = g;
      if (mat) { try { mat.setEmissiveFactor([g, g * .66, g * .34]); } catch (e) {} }
      mv.exposure = .55 + g * .55;
    }
    mv.addEventListener('load', function () {
      try {
        mat = mv.model.materials[0];
        var t = mat.pbrMetallicRoughness.baseColorTexture && mat.pbrMetallicRoughness.baseColorTexture.texture;
        if (t) mat.emissiveTexture.setTexture(t);
      } catch (e) {}
      lastG = -1; setGlow(state.glow);
      root.classList.add('mn-x3d--loaded');
    });
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { state.glow = .6; setGlow(.6); chs.forEach(function (c) { c.style.setProperty('--o', 1); }); return; }
    root.classList.add('mn-x3d--on');
    var sky = initSky(root, root.querySelector('.mn-x3d__sky'), state);

    function progress() {
      var r = track.getBoundingClientRect(); var total = r.height - window.innerHeight;
      return total > 0 ? clamp(-r.top / total, 0, 1) : 0;
    }
    function update() {
      var p = progress(), x = p * (n - 1), i = Math.min(n - 2, Math.floor(x)), f = x - Math.max(0, i);
      if (n === 1) { i = 0; f = 0; }
      var a = kf[Math.max(0, i)], b = kf[Math.min(n - 1, i + 1)];
      var e = ease(clamp((f - .2) / .6, 0, 1));
      var th = lerp(a.th, b.th, e) + (f - .5) * 8, ph = lerp(a.ph, b.ph, e), zm = lerp(a.zm, b.zm, e);
      mv.cameraOrbit = th.toFixed(2) + 'deg ' + ph.toFixed(2) + 'deg ' + zm.toFixed(1) + '%';
      var g = glowAt(x); state.p = p; state.x = x; state.glow = g; setGlow(g);
      root.style.setProperty('--p', p.toFixed(4)); root.style.setProperty('--glow', g.toFixed(3));
      var k = clamp(Math.round(x), 0, n - 1), lv = 0, tm = 0, br = 0;
      chs.forEach(function (c, j) {
        var d = x - j, o = clamp(1 - Math.abs(d) * 2.3, 0, 1);
        c.style.setProperty('--o', o.toFixed(3)); c.style.setProperty('--dy', (-d * 70).toFixed(1) + 'px');
        c.classList.toggle('is-active', o > .55);
        if (kf[j].ef === 'levels') lv = Math.max(lv, o);
        if (kf[j].ef === 'timer') {
          tm = Math.max(tm, o);
          var lt = clamp((x - (j - .35)) / .73, 0, 1);
          root.style.setProperty('--to', (lt * 100).toFixed(1));
          if (clock) { var m = Math.round(30 * (1 - lt)); clock.textContent = (m < 10 ? '0' : '') + m + ':00'; }
        }
        if (kf[j].ef === 'breath') br = Math.max(br, o);
      });
      root.style.setProperty('--lv', lv.toFixed(3)); root.style.setProperty('--tm', tm.toFixed(3));
      state.breath = br;
      lvEls.forEach(function (s) { s.classList.toggle('is-on', g >= (+s.dataset.l) - .02 && lv > .2); });
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === k); });
    }
    var visible = true, ticking = false;
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; update(); }); } }
    window.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) loop(); }, { rootMargin: '100px' }).observe(root);
    var t0 = performance.now(), running = false;
    function loop() {
      if (running) return; running = true;
      (function frame(now) {
        if (!visible) { running = false; return; }
        sky();
        if (state.breath > .01) { var s = 1 + .018 * state.breath * Math.sin((now - t0) / 4000 * 6.283); body.style.transform = 'scale(1,' + s.toFixed(4) + ')'; }
        else if (body.style.transform) body.style.transform = '';
        requestAnimationFrame(frame);
      })(performance.now());
    }
    update(); loop();
  }
  function boot() { document.querySelectorAll('[data-mn-x3d]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
